import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { helpfulPlaceholder } from '../../constants/placeholder';
import {
  useGetCustomSelectButtonElement,
  useSetMultipleRangeDefaultValue,
} from '../../hooks/init';
import CustomSelect from '../../components/CustomSelect';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
const options = [
  { text: '0 ~ 5 people', value: '0-5' },
  { text: '5 ~ 10 people', value: '5-10' },
  { text: '10 ~ 20 people', value: '10-20' },
  { text: '> 20 people', value: '20-' },
];
export default function HelpfulSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { formatOptionsMessage, formatMessage } = useLanguage();
  const { rangeValue, setRangeValue, diffClassName } =
    useSetMultipleRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'helpfuls',
      startKey: 'start_helpful',
      endKey: 'end_helpful',
      options,
    });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    const data: { start_helpful: number; end_helpful?: number | undefined }[] =
      [];
    rangeValue.map((item: string) => {
      const [start, end] = item.split('-');
      let dataItem: { start_helpful: number; end_helpful?: number } = {
        start_helpful: Number(start),
      };
      if (end !== '') {
        dataItem['end_helpful'] = Number(end);
      }
      data.push(dataItem);
    });

    onChange?.(
      'helpfuls',
      commonBackInfo(
        { helpfuls: data },
        { helpfuls: text },
        {
          needChangeEntity: true,
          defaultValue: { end_helpful: -99999, start_helpful: -99999 },
          isAll,
        },
      ),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={helpfulPlaceholder[lang]}
        onClear={() => setRangeValue([] as any)}
        showNumber={3}
        selectOptionsInfo={[rangeValue, setRangeValue]}
        options={formatOptionsMessage(options)}
        pointKey={FilterButtonPoint.helpfuls}
      ></CustomSelect>
    </div>
  );
}
